import React from "react";
import { DynamicFieldAddress } from "../components/fields/DynamicFieldAddress";
import { DynamicFieldBoolean } from "../components/fields/DynamicFieldBoolean";
import { DynamicFieldCurrency } from "../components/fields/DynamicFieldCurrency";
import { DynamicFieldDate } from "../components/fields/DynamicFieldDate";
import { DynamicFieldEnum } from "../components/fields/DynamicFieldEnum";
import { DynamicFieldNumber } from "../components/fields/DynamicFieldNumber";
import { DynamicFieldReadOnly } from "../components/fields/DynamicFieldReadOnly";
import { DynamicFieldSignature } from "../components/fields/DynamicFieldSignature";
import { DynamicFieldMaskedId } from "../components/fields/DynamicFieldMaskedId";
import { DynamicFieldText } from "../components/fields/DynamicFieldText";
import { FormFieldType, IDynamicFieldProps } from "../types";

type FieldComponent = React.ComponentType<
  IDynamicFieldProps & { value?: unknown }
>;

export const fieldTypeComponentMap: Record<FormFieldType, FieldComponent> = {
  String: DynamicFieldText,
  Number: DynamicFieldNumber,
  Currency: DynamicFieldCurrency,
  Percent: DynamicFieldNumber,
  Enum: DynamicFieldEnum,
  Boolean: DynamicFieldBoolean,
  Date: DynamicFieldDate,
  Address: DynamicFieldAddress,
  // MaskedId reuses the SSN-style masked input; it honours `field.ui.mask`.
  MaskedId: DynamicFieldMaskedId,
  SignatureBlock: DynamicFieldSignature,
  ReadOnly: DynamicFieldReadOnly,
  // Group is dispatched directly by DynamicFormFieldRenderer — its rows render
  // through the renderer, so importing DynamicFieldGroup here would create a
  // module-init import cycle (this map's object literal evaluates eagerly).
  // The stub only satisfies the exhaustive Record type.
  Group: () => null
};

export const resolveFieldComponent = (
  fieldType: FormFieldType
): FieldComponent | undefined => fieldTypeComponentMap[fieldType];
